import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';
import type { Service, ServiceCategory, Tenant } from './db/types';

export interface PublicProvider {
  id: string;
  name: string;
  photoUrl?: string;
}

export interface PublicLocation {
  id: string;
  name: string;
  timezone?: string;
  address?: string;
}

export interface PublicBookingCatalog {
  tenant: Tenant & { id: string };
  services: Array<Service & { id: string }>;
  categories: Array<ServiceCategory & { id: string }>;
  providers: PublicProvider[];
  locations: PublicLocation[];
}

export interface PublicAppointmentDetails {
  appointment: {
    id: string;
    tenantId: string;
    serviceId: string;
    providerId: string;
    startTime: string;
    endTime: string;
    status: string;
    paymentStatus: string;
    customerType: 'member' | 'guest';
    guestInfo?: {
      firstName: string;
      lastName: string;
      email: string;
      phone?: string;
    } | null;
    source: string;
    attendees: number;
    publicAccessHash: string;
  };
  tenant: Tenant & { id: string };
  service: {
    id: string;
    name: string;
    duration: number;
    price?: number;
    currency?: string;
    color?: string;
    locationId?: string | null;
  } | null;
  provider: PublicProvider | null;
  location: PublicLocation | null;
}

export async function getPublicBookingCatalog(tenantSlug: string): Promise<PublicBookingCatalog> {
  const fn = httpsCallable(functions, 'getPublicBookingCatalog');
  const result = await fn({ tenantSlug });
  return result.data as PublicBookingCatalog;
}

export async function getPublicAppointment(publicAccessHash: string): Promise<PublicAppointmentDetails> {
  const fn = httpsCallable(functions, 'getPublicAppointment');
  const result = await fn({ publicAccessHash });
  return result.data as PublicAppointmentDetails;
}
